/**
 * Whether a rejected submit actually means "the entry is already on the ticket" (MSPPROC-19105).
 *
 * `POST /call-scribe/calls/{id}/time-entry` answers **409 Conflict** when the call already has a
 * posted link — the claim guard refusing a second write because the automatic trigger, or another
 * click, won the claim first. The request failed; the technician's goal did not. Treating it as an
 * error is what made an error message flash up and be replaced by the success screen a tick later.
 *
 * Kept as its own predicate rather than an inline status check so it can be tested against the
 * shapes an error actually arrives in — a thunk's `unwrap()` rejection is not the axios error, and
 * asserting against only one of them is how this would silently stop matching.
 */
export const ALREADY_POSTED_STATUS = 409;

export const alreadyPosted = (err: unknown): boolean => {
  if (err === null || typeof err !== 'object') {
    return false;
  }

  const candidate = err as {
    status?: unknown;
    response?: { status?: unknown };
    payload?: { status?: unknown };
  };

  return (
    candidate.status === ALREADY_POSTED_STATUS
    || candidate.response?.status === ALREADY_POSTED_STATUS
    || candidate.payload?.status === ALREADY_POSTED_STATUS
  );
};
